import { Editor } from './editor';

export function activateEditor(editor: Editor, right: boolean) {
  //removes cursor if exists
  const selection = document.getSelection();
  if (selection) {
    selection.removeAllRanges();
  }
  editor.activate(right);
}

export function setTextCursor(n: Node, offset: number) {
  const range = document.createRange();
  range.setStart(n, offset ? offset : 0);
  range.collapse(true);
  const sel = document.getSelection();
  if (sel) {
    sel.removeAllRanges();
    sel.addRange(range);
  }
}

export function setCursorOnTag(el: Element) {
  const range = document.createRange();
  const p = el.parentNode as Node;
  for (let i = 0; i < p.childNodes.length; i++) {
    if (p.childNodes[i] === el) {
      range.setStart(p, i);
      range.collapse(true);
      const sel = document.getSelection();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
      }
      break;
    }
  }
}
